// メインビジュアル内インラインJS移植

$(window).on("load", function () {
  if (!window.matchMedia("(max-width:959px)").matches) {
    if ($(".c-header-promotion").length) {
      var $newsH = $(".c-header-promotion").innerHeight();
      $(".c-top-keyvisual").css({
        "padding-top": $newsH + "px"
      });
      $("main").css({
        "padding-top": "0"
      });
      $(".c-header").css({
        "top": 0
      })
    }
  } else {
    if ($(".c-header-promotion").length) {
      var $newsH = $(".c-header-promotion").innerHeight();
      $(".c-top-keyvisual").css({
        "padding-top": $newsH + "px"
      });
    }
  }
});

function addClassHeader() {
  if ($(window).scrollTop() > 30) {
    $('.c-header').addClass('is-bg');
    $('.c-header').removeClass('is-white');
  } else {
    if ($('.c-header-menu-button').hasClass('-is-open') == false) {
      $('.c-header').removeClass('is-bg');
      $('.c-header').addClass('is-white');

    }
  }
};

if (window.matchMedia("(max-width:959px)").matches) {
  addClassHeader();
}

$(window).on('scroll', function () {
  if (window.matchMedia("(max-width:959px)").matches) {
    addClassHeader();
  }
});

const targetElement = document.querySelector('.c-header-menu-button');
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.attributeName === 'class') {
      if (window.matchMedia("(max-width:959px)").matches) {

        if (mutation.target.classList.contains('-is-open') == true) {
          $('.c-header').removeClass('is-white');
        } else {
          if ($(window).scrollTop() < 30) {
            $('.c-header').removeClass('is-bg');
            $('.c-header').addClass('is-white');
          } else {
            $('.c-header').addClass('is-bg');
            $('.c-header').removeClass('is-white');
          }
        }
      }
    }
  });
});
const config = {
  attributes: true
};
observer.observe(targetElement, config);

// MidNight処理
function midnight() {
  let mediaQuery = window.matchMedia("screen and (max-width: 959px)");
  if(!mediaQuery.matches) {
    $("main").hasClass("p-top") && $(".js-nav, .js-header, .js-menu").midnight();

    // 2025.1.15 Add
    var promoHeight = $(".c-header-sale, .utility-bar.c-header-promotion").outerHeight();
    $(".js-nav, .js-header, .js-menu").css("top", 25 + promoHeight);

    // 2025.1.22 Add
    // 検索窓の開閉に伴う位置の再調整
    const targetElement = document.querySelector('.js-toggle-item[data-toggle-item="search"]');
    // targetElementのclass属性の変化を監視
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          if (mutation.target.classList.contains('-is-open') == true) {
            console.log('open');
            $(".js-nav, .js-header, .js-menu").css("top", 25 + promoHeight + 81);
          } else {
            console.log('close');
            $(".js-nav, .js-header, .js-menu").css("top", 25 + promoHeight);
          }
        }
      });
    });
    const config = { attributes: true };
    observer.observe(targetElement, config);
  }
}

// TOPページスライダー系JS移植
function topSlider() {
  let mediaQuery = window.matchMedia("screen and (max-width: 959px)");

  $(".js-news-slide").each(function() {
    $(this).css("visibility", "visible").slick({
      arrows: false,
      dots: false,
      autoplay: false,
      mouseDrag: true,
      centerMode: false,
      slidesToShow: 4,
      swipeToSlide: true,
      touchThreshold: 100,
      cssEase: 'linear',
      speed: 150,
      responsive: [{
        arrows: false,
        breakpoint: 960,
        settings: {
          slidesToScroll: 2,
          swipeToSlide: false,
          slidesToShow: 2
        }
      }]
    });
  });

  if(!mediaQuery.matches) {    
    $(".js-inside-slide").css("visibility", "visible").not(".slick-initialized").slick({
      nav: true,
      dots: true,
      dotsClass: "c-top-inside__dots",
      fade: true,
      autoplay: true,
      mouseDrag: true,
      centerMode: false,
      prevArrow: $(".c-top-inside__prev"),
      nextArrow: $(".c-top-inside__next")
    }),
    $(".c-item-list__prev, .c-item-list__next").css("visibility", "visible");
  }
}

function sliderVideoShow() {
  $(".c-top-inside__button").on("click", function() {
    $(".c-top-inside__video").css("z-index", "2"),
    playVideo("playVideo")
  }),
  $(".c-collection__button").on("click", function() {
    $(".c-collection__video iframe").css("z-index", "2"),
    playVideo("playVideo")
  })
}

function playVideo(option) {
  $("#vw-video")[0].contentWindow.postMessage('{"event":"command","func":"' + option + '","args":""}', "*")
}

window.addEventListener('DOMContentLoaded',function(){
  midnight();
  topSlider();
  //sliderVideoShow();
})

// 画面幅が変わった時にmidnight()を再度実行
window.addEventListener('resize', function() {
  midnight();
});